import logo from '../images/logo_fazendinha.jpg';

const styles = {
    header: {
        width: '100%',
        backgroundColor: '#D3873B',
        display: 'flex',
        justifyContent: 'center',
    },
    image: {
        height: 100,
    },
};

function Header(){
    return (
        <div style={styles.header}>
            <img src={logo} alt={'Fazendinha Sabiá'} style={styles.image}/>
        </div>
    );
}

export default Header;